export default __webpack_public_path__ + "static/media/newsletter.45cb4546.svg";